import { useCallback } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { useAppContext } from '../App';

export const useTelemetry = () => {
    const { authUser, userProfile } = useAppContext();

    const transmitTelemetry = useCallback(async (telemetryData) => {
        if (!authUser) {
            console.warn("[Telemetry] Blocked: No authenticated session found.");
            return null;
        }

        try {
            // --- O(1) DENORMALIZATION PATCH ---
            // Flattening the tenant ID directly into the subcollection.
            // This allows firestore.rules to evaluate the boundary at zero latency 
            // without requiring a recursive get() call to the parent user document.
            const telemetryPayload = {
                ...telemetryData,
                enterpriseTenantId: userProfile?.enterpriseTenantId || 'public',
                timestamp: serverTimestamp()
            };

            const docRef = await addDoc(
                collection(db, 'users', authUser.uid, 'telemetry_log'), 
                telemetryPayload
            );
            
            return docRef.id;
        } catch (error) {
            console.error("[Telemetry] Failed to transmit payload:", error);
            return null;
        }
    }, [authUser, userProfile]);

    // Convenience exports mapped directly from the user's live profile
    const vciScore = userProfile?.vciScore || 0;
    const readinessTier = userProfile?.readinessTier || "Tier 1: Baseline";

    return {
        transmitTelemetry,
        vciScore,
        readinessTier
    };
};